import { memo } from 'react';
import PropTypes from 'prop-types';

import { Error, Success } from 'basic-components/icons';

import { When } from 'react-if';

import classNames from 'classnames';
import './HeaderStep.scss';

const HeaderStep = ({ isActive, onClick, isDisabled = false, isError, isSuccess, number, label }) => (
  <div 
      className={classNames(
        "ncsv-creator__top__header__element",
        { "ncsv-creator__top__header__element--is-active": isActive },
        { "ncsv-creator__top__header__element--is-disabled": !isError && !isSuccess && !isActive && isDisabled }
      )}
      onClick={onClick}
  >
    <div className={classNames(
      "ncsv-creator__top__header__element__status",
      { "ncsv-creator__top__header__element__status--is-status": isError || isSuccess },
      { "ncsv-creator__top__header__element__status--is-disabled": !isError && !isSuccess && !isActive && isDisabled }
    )}>
      <When condition={isError}>
        {() => (
          <Error
              bgColor="red-base"
              color="white-base"
              height={24}
              width={24}
          />
        )}
      </When>
      <When condition={isSuccess}>
        {() => (
          <Success
              bgColor="green-fresh"
              color="white-base"
              height={24}
              width={24}
          />
        )}
      </When>
      <When condition={!isError && !isSuccess}>
        {() => (
          <div className="ncsv-creator__top__header__element__status__number">{number}</div>
        )}
      </When>
    </div>
    <div className="ncsv-creator__top__header__element__label">
      {label}
    </div>
  </div>
)

HeaderStep.propTypes = {
  isActive: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
  isError: PropTypes.bool.isRequired,
  isSuccess: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  number: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default memo(HeaderStep)